import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { memberPrescriptionClaimsWidget as MemberPrescriptionClaimsWidgetView } from 'ui/views/widgets/memberPrescriptionClaimsWidget';
import { MemberPrescriptionClaimsWidgetService } from 'services/memberPrescriptionClaimsWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import searchQuery from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberPrescriptionClaimsWidget } from 'ui/containers/MemberPrescriptionClaimsWidget';
 *
 * // render
 * <MemberPrescriptionClaimsWidget propName='propValue'/>
 */
class _MemberPrescriptionClaimsWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind methods to instance
        this.handleActionClick = this.handleActionClick.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // member prescriptions instance
        this.memberPrescriptionRefillsWidgetService = new MemberPrescriptionClaimsWidgetService();

        // start member detail data fetch
        this.fetchComponentData();
    }

    async fetchComponentData() {
        log.debug( 'MemberPrescriptionClaimsWidget.fetchComponentData()' );
        
         // cancel ongoing request
         this.memberPrescriptionRefillsWidgetService.cancel();

        try {
            const { status, data }  = await this.memberPrescriptionRefillsWidgetService.fetchComponentData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'MemberPrescriptionClaimsWidget.handleActionClick()' );

        const memberId = get( this.props.location, 'state.memberId', undefined );

        if( 'column' === type && 'claimNumber' === value.name  ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.CLAIM_DETAIL,
                search: searchQuery.stringify( {
                    claimId: item.id
                } ),
                state: { memberId: memberId }
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberPrescriptionClaimsWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberPrescriptionClaimsWidget.displayName = '_MemberPrescriptionClaimsWidget';

// set default props
_MemberPrescriptionClaimsWidget.defaultProps = {};

// prop types
_MemberPrescriptionClaimsWidget.propTypes = {};

/*******************************************/

// provider router props
export const MemberPrescriptionClaimsWidget = withRouter( _MemberPrescriptionClaimsWidget );
